import { isEqual } from 'es-toolkit';
import React, { memo } from 'react';

import { Point2D as Point2DInterface } from '@paragon/contract-library';

import { useAppSelector } from '../../components/hooks';
import { getDistanceFormatterSelector } from '../../store/selectors/getDistanceFormatterSelector';
import { DistanceDimension } from './DistanceDimension';

const QUICK_DIMENSION_DEFAULT_THICKNESS = 0.1;

interface Props {
  readonly start: Point2DInterface;
  readonly end: Point2DInterface;

  readonly distance: number;
  readonly textFloat?: number;

  readonly thickness?: number;
  readonly showEndpointMarks?: boolean;
}

function propsAreEqual(first: Props, second: Props) {
  return (
    isEqual(first.start, second.start) &&
    isEqual(first.end, second.end) &&
    first.distance === second.distance &&
    first.textFloat === second.textFloat
    // thickness and endpoint mark visibility are not expected to change dynamically
  );
}

export const QuickDistanceDimension = memo((props: Props) => {
  const distanceFormatter = useAppSelector(getDistanceFormatterSelector);
  return (
    <DistanceDimension
      segment={{ start: props.start, end: props.end }}
      labelData={{ firstNumber: props.distance }}
      showEndpointMarks={props.showEndpointMarks}
      distanceFormatter={distanceFormatter}
      thickness={props.thickness ?? QUICK_DIMENSION_DEFAULT_THICKNESS}
      orientText
      textFloat={props.textFloat}
    />
  );
}, propsAreEqual);
